import { render } from "./doctor-blog.vue?vue&type=template&id=0593995e"
import script from "./doctor-blog.vue?vue&type=script&lang=js"
export * from "./doctor-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__